<!--
 * @Author: your name
 * @Date: 2021-09-20 10:09:13
 * @LastEditTime: 2021-12-26 17:03:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Bounty\src\views\PC\My\My.vue
-->
<template>
  <div>
    <div class="my">
      <div v-if="[2].includes(show)" class="my-des">
        <div class="my-left">
          <div class="login">
            <div class="login-icon"  v-if="!bountyIcon">
              <div class="login-red-box"></div>
            </div>
            <img v-else :src="bountyIcon" alt="img" class="bounty-icon">
          </div>
          <div class="right-box">
            <div class="bountyName">{{bountyName}}</div>
            <div class="token">
              <span>{{token | tokenFilter}}</span>
              <svg @click="copyUrl" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.3086 4.50073H6.50391C5.39718 4.50073 4.5 5.39791 4.5 6.50464V14.3093C4.5 15.4161 5.39718 16.3132 6.50391 16.3132H14.3086C15.4153 16.3132 16.3125 15.4161 16.3125 14.3093V6.50464C16.3125 5.39791 15.4153 4.50073 14.3086 4.50073Z" stroke="white" stroke-width="1.5" stroke-linejoin="round"/>
                <path d="M13.4824 4.50049L13.5 3.65674C13.4985 3.13505 13.2906 2.63515 12.9217 2.26626C12.5528 1.89737 12.0529 1.68947 11.5312 1.68799H3.9375C3.3413 1.68975 2.77003 1.92737 2.34846 2.34894C1.92688 2.77052 1.68926 3.34179 1.6875 3.93799V11.5317C1.68898 12.0534 1.89688 12.5533 2.26577 12.9222C2.63466 13.2911 3.13456 13.499 3.65625 13.5005H4.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="token-tip" v-show="showCopy">Copied address</div>
          </div>
        </div>
        <div class="my-right" style="position: relative">
          <!-- <div @click="goList">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M30.0709 24.7094C28.2652 22.4995 26.9905 21.3745 26.9905 15.2819C26.9905 9.70264 24.1414 7.7149 21.7965 6.74951C21.485 6.62154 21.1918 6.32764 21.0969 6.00771C20.6855 4.60779 19.5324 3.37451 17.9996 3.37451C16.4668 3.37451 15.313 4.6085 14.9059 6.00912C14.8109 6.33256 14.5177 6.62154 14.2063 6.74951C11.8585 7.71631 9.01227 9.69701 9.01227 15.2819C9.00875 21.3745 7.73399 22.4995 5.92836 24.7094C5.18024 25.6249 5.83555 26.9995 7.14407 26.9995H28.8622C30.1637 26.9995 30.8148 25.6207 30.0709 24.7094Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M22.5 26.9983V28.1233C22.5 29.3168 22.0259 30.4614 21.182 31.3053C20.3381 32.1492 19.1935 32.6233 18 32.6233C16.8065 32.6233 15.6619 32.1492 14.818 31.3053C13.9741 30.4614 13.5 29.3168 13.5 28.1233V26.9983" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span class="message-num" v-if="messageNum !== 0">{{messageNum}}</span> -->
          <div @click="toEdit">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.4428 13.5223C17.5195 13.4311 16.5906 13.6275 15.7832 14.0847C14.9759 14.5418 14.3296 15.2373 13.9328 16.076C13.536 16.9146 13.4081 17.8554 13.5667 18.7695C13.7253 19.6837 14.1625 20.5264 14.8185 21.1825C15.4746 21.8385 16.3173 22.2757 17.2315 22.4343C18.1456 22.5928 19.0864 22.465 19.925 22.0682C20.7637 21.6714 21.4592 21.0251 21.9163 20.2178C22.3735 19.4104 22.5699 18.4815 22.4787 17.5582C22.3748 16.5232 21.9161 15.556 21.1806 14.8204C20.445 14.0849 19.4778 13.6262 18.4428 13.5223V13.5223ZM29.2779 18.0005C29.2751 18.4896 29.2391 18.978 29.1703 19.4623L32.3492 21.9556C32.4876 22.0703 32.5809 22.2304 32.6124 22.4074C32.6439 22.5844 32.6117 22.7669 32.5214 22.9224L29.5142 28.1255C29.4228 28.2795 29.2801 28.3963 29.1111 28.4553C28.9421 28.5144 28.7576 28.5119 28.5903 28.4482L25.4332 27.177C25.2591 27.1077 25.0706 27.0826 24.8844 27.1041C24.6983 27.1256 24.5203 27.1929 24.3666 27.3C23.8848 27.6318 23.3785 27.9266 22.8521 28.1817C22.6866 28.2622 22.5434 28.3821 22.4353 28.531C22.3271 28.6799 22.2573 28.8531 22.2319 29.0353L21.7587 32.4026C21.7276 32.5804 21.6358 32.7419 21.4988 32.8595C21.3618 32.9771 21.1883 33.0435 21.0078 33.0474H14.9932C14.8157 33.0443 14.6446 32.9808 14.5079 32.8675C14.3713 32.7541 14.2774 32.5976 14.2416 32.4237L13.7691 29.0613C13.7426 28.8771 13.6709 28.7022 13.5605 28.5523C13.4501 28.4024 13.3044 28.2821 13.1363 28.2021C12.6105 27.9483 12.1059 27.6528 11.6274 27.3183C11.4742 27.2117 11.2968 27.1449 11.1114 27.1239C10.9259 27.1029 10.7381 27.1284 10.565 27.1981L7.40864 28.4686C7.24137 28.5323 7.05699 28.5349 6.88798 28.476C6.71896 28.4171 6.57616 28.3004 6.48473 28.1466L3.47746 22.9435C3.38705 22.788 3.35474 22.6055 3.38629 22.4285C3.41783 22.2514 3.51119 22.0913 3.64973 21.9767L6.33637 19.8673C6.48356 19.7504 6.59924 19.5987 6.67291 19.4258C6.74658 19.2529 6.77592 19.0644 6.75824 18.8773C6.73293 18.5841 6.71746 18.2916 6.71746 17.9984C6.71746 17.7052 6.73223 17.4169 6.75824 17.13C6.77398 16.9441 6.74321 16.7571 6.66871 16.586C6.5942 16.4149 6.4783 16.265 6.33145 16.1499L3.64621 14.0405C3.50992 13.9252 3.41853 13.7657 3.38807 13.5898C3.3576 13.414 3.38999 13.233 3.47957 13.0786L6.48684 7.87549C6.57816 7.7215 6.72092 7.60468 6.88994 7.54564C7.05896 7.4866 7.2434 7.48912 7.41074 7.55275L10.5678 8.824C10.7419 8.89332 10.9304 8.91836 11.1166 8.89689C11.3028 8.87542 11.4807 8.80809 11.6344 8.70096C12.1162 8.36917 12.6225 8.07441 13.1489 7.81924C13.3144 7.7388 13.4576 7.61885 13.5658 7.46998C13.6739 7.32111 13.7437 7.1479 13.7691 6.96564L14.2423 3.59838C14.2734 3.42055 14.3653 3.25903 14.5022 3.14142C14.6392 3.02382 14.8128 2.95744 14.9932 2.95361H21.0078C21.1853 2.95668 21.3565 3.02013 21.4931 3.1335C21.6297 3.24686 21.7236 3.40339 21.7594 3.57728L22.2319 6.93963C22.2584 7.12389 22.3301 7.29875 22.4405 7.44865C22.5509 7.59855 22.6966 7.71884 22.8647 7.79885C23.3905 8.05264 23.8951 8.3482 24.3736 8.68267C24.5268 8.78928 24.7042 8.85608 24.8896 8.87707C25.0751 8.89806 25.2629 8.87258 25.4361 8.80291L28.5924 7.53236C28.7596 7.46867 28.944 7.46604 29.113 7.52495C29.282 7.58386 29.4248 7.70053 29.5163 7.85439L32.5235 13.0575C32.614 13.213 32.6463 13.3955 32.6147 13.5725C32.5832 13.7496 32.4898 13.9097 32.3513 14.0243L29.6646 16.1337C29.5168 16.2501 29.4005 16.4017 29.3262 16.5746C29.2519 16.7475 29.222 16.9363 29.2393 17.1237C29.2625 17.4148 29.2779 17.7073 29.2779 18.0005Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <!-- <div @click="exitWallet">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M26.5782 7.59399C28.1171 8.85661 29.3568 10.4449 30.2079 12.2443C31.059 14.0438 31.5003 16.0097 31.5001 18.0002C31.5001 25.4534 25.4532 31.5002 18.0001 31.5002C10.5469 31.5002 4.50006 25.4534 4.50006 18.0002C4.49415 16.0157 4.92585 14.0543 5.76442 12.2556C6.60298 10.457 7.82778 8.86532 9.35162 7.59399" stroke="#FF7676" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18 4.50122V18.0012" stroke="#FF7676" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div> -->
        </div>
      </div>
      <div v-if="show === 1">
        <bounty-back :title="$t('My.My')" @goBack="()=>{this.show = 2}"></bounty-back>
        <div class="my-title">{{$t('My.EditProfile')}}</div>
        <el-form ref="form" :label-position="'top'" class="form_wrap" id="form_my">
          <div class="form-box">
            <el-form-item :label="$t('My.Nickname')">
              <el-input :disabled="isDisabled" v-model="formData.userName"></el-input>
            </el-form-item>
            <el-form-item :label="$t('My.PandaID')">
              <el-input :disabled="true" v-model="formData.pandaId"></el-input>
            </el-form-item>
          </div>
          <div class="form-box">
            <el-form-item :label="$t('My.Email')">
              <el-input :disabled="isDisabled" v-model="formData.email"></el-input>
            </el-form-item>
            <el-form-item :label="$t('My.PandaState')">
              <el-input :disabled="true" v-model="formData.pandaStatus"></el-input>
            </el-form-item>
          </div>
          <el-form-item :label="$t('My.NoteInformation')">
            <el-input :disabled="isDisabled" type="textarea" :autosize="{minRows:4}" v-model="formData.remarks"></el-input>
          </el-form-item>
          <el-form-item class="upload-file" :label="$t('My.HeadPortrait')">
            <el-upload
                class="avatar-uploader img_upload"
                :action="action"
                :disabled="isDisabled"
                :headers="headerObj"
                :name="'mFile'"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-error="handleError"
                :before-upload="beforeAvatarUploadImage">
                <img v-if="formData.headPortrait" :src="formData.headPortrait" class="avatar">
                <svg v-else width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M30 39.376C34.1421 39.376 37.5 36.0181 37.5 31.876C37.5 27.7338 34.1421 24.376 30 24.376C25.8579 24.376 22.5 27.7338 22.5 31.876C22.5 36.0181 25.8579 39.376 30 39.376Z" fill="#3B3A40"/>
                  <path d="M53.4387 16.8784H43.7121C43.3606 16.8784 42.9246 16.6511 42.5848 16.2925L39.3879 11.2769C38.0871 9.37842 37.5012 9.37842 35.3918 9.37842H24.6106C22.5012 9.37842 21.7981 9.37842 20.618 11.278L17.4176 16.2925C17.1575 16.5761 16.7918 16.8784 16.4075 16.8784V15.0034C16.4075 14.7548 16.3087 14.5163 16.1329 14.3405C15.9571 14.1647 15.7186 14.0659 15.47 14.0659H10.7825C10.5338 14.0659 10.2954 14.1647 10.1196 14.3405C9.94374 14.5163 9.84497 14.7548 9.84497 15.0034V16.8784H6.56372C5.8178 16.8784 5.10243 17.1747 4.57498 17.7022C4.04754 18.2296 3.75122 18.945 3.75122 19.6909V47.8159C3.75122 48.5618 4.04754 49.2772 4.57498 49.8047C5.10243 50.3321 5.8178 50.6284 6.56372 50.6284H53.4387C54.1846 50.6284 54.9 50.3321 55.4274 49.8047C55.9549 49.2772 56.2512 48.5618 56.2512 47.8159V19.6909C56.2512 18.945 55.9549 18.2296 55.4274 17.7022C54.9 17.1747 54.1846 16.8784 53.4387 16.8784ZM30.5297 43.1167C28.2622 43.2232 26.0155 42.6413 24.0848 41.4473C22.1541 40.2533 20.6298 38.5033 19.7121 36.427C18.7945 34.3507 18.5264 32.0454 18.9431 29.8139C19.3598 27.5825 20.4418 25.5293 22.0469 23.9241C23.6521 22.319 25.7053 21.237 27.9367 20.8203C30.1682 20.4036 32.4735 20.6717 34.5498 21.5893C36.6261 22.507 38.3761 24.0313 39.5701 25.962C40.764 27.8927 41.346 30.1394 41.2395 32.4069C41.1052 35.204 39.9337 37.8507 37.9536 39.8308C35.9735 41.8109 33.3268 42.9824 30.5297 43.1167Z" fill="#3B3A40"/>
                </svg>
              </el-upload>
          </el-form-item>
          <!-- <div class="form-box">
            <el-form-item :label="$t('My.IdentityCategories')">
              <el-select class="w-240" v-model="formData.IdentityCategories">
                <el-option label="乘客" :value="0"></el-option>
                <el-option label="车主" :value="1"></el-option>
                <el-option label="司机" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('My.NoteInformation')">
              <el-input v-model="formData.NoteInformation"></el-input>
            </el-form-item>
          </div> -->
          <div class="saveBtn cancelselect" @click="saveUserInfo">{{$t('My.Save')}}</div>
        </el-form>
      </div>
      <task-list ref="taskList" v-else-if="show === 2" @createProject="createProjectFn" @createTask="createTaskFn"></task-list>
      <create-task v-else-if="show === 3"></create-task>
      <create-project-task ref="createProjectTask" :DATA="taskData" :isEdit="taskIsEdit" :isView="taskView" v-else-if="show === 4" @backMy="backMyProject"></create-project-task>
      <create-project v-else-if="show === 5" :DATA="projectData" :isEdit="projectIsEdit" :isView="projectIsView" @backMy="backMy"></create-project>
      <message-b v-else-if="show === 6" @goBack="goBack"></message-b>
    </div>
    <bounty-footer></bounty-footer>
  </div>
</template>

<script>
import taskList from './components/list'
import createTask from './components/createTask'
import createProjectTask from './components/createProjectTask'
import createProject from './components/createProject'
import messageB from './components/message'
import { eventBus } from '@/plugin/eventBus/index.js'

import { getMyProfile, updateMyProfile, getMyNoticeCountToRead } from '@/api/bounty.js'

export default {
  name: 'My',
  data () {
    return {
      uploadLoading: '',
      action: baseUrl + '/bounty/files/uploadFile',
      messageNum: 0,
      projectData: {}, // 项目信息
      projectIsEdit: false,
      projectIsView: false,
      taskData: {}, // 任务信息
      taskIsEdit: false,
      taskView: false,
      bountyName: 'Bounty name',
      bountyIcon: '',
      token: '',
      showCopy: false,
      formData: {
        id: '',
        userName: '',
        pandaId: '',
        email: '',
        pandaStatus: '',
        // IdentityCategories: '',
        remarks: '',
        headPortrait: ''
      },
      show: 2,
      isDisabled: true,
      headerObj: {
        token: sessionStorage.getItem('bountyToken'),
        walletAddress: sessionStorage.getItem('walletAddress')
      }
    }
  },
  beforeRouteEnter: (to, from, next) => {
    next(vm => {
      if (!sessionStorage.getItem('walletAddress')) {
        vm.$router.push({ name: 'Index' })
      } else {
        // 跳转message
        if (vm.$route.params.message) {
          vm.show = 6
        }
      }
    })
  },
  mounted () {
    // 根据各种状态判断进入哪个组件
    // console.log(this.$route)
    eventBus.$on('createTask', () => {
      this.show = 4
      this.taskData = {}
    })
    eventBus.$on('showMyList', () => {
      this.show = 2
    })
    // console.log('this.$route.', this.$route)
    if (this.$route.params.showCreateTask) {
      this.show = 4
    }
    if (this.$route.params.allReadySubmit) {
      this.show = 2
      this.$nextTick(() => {
        this.$refs.taskList.currNum = 2
        this.$refs.taskList.getProposalList()
      })
    }
    this.token = sessionStorage.getItem('walletAddress')
    if (sessionStorage.getItem('userInfo')) {
      this.bountyName = JSON.parse(sessionStorage.getItem('userInfo')).userName || 'Bounty name'
      this.bountyIcon = JSON.parse(sessionStorage.getItem('userInfo')).headPortrait || ''
    }
  },
  components: {
    taskList,
    createTask,
    createProjectTask,
    createProject,
    messageB
  },
  methods: {
    /**
     * @description: 返回我的列表页面
     * @param {*}
     * @return {*}
     */
    backMy () {
      this.show = 2
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    backMyProject () {
      this.show = 2
      this.taskView = false
      // this.$refs.taskList.currNum = 1
      this.$nextTick(() => {
        this.$refs.taskList.currNum = 1
        this.$refs.taskList.getMyTaskList()
      })
    },
    /**
     * @description: 创建项目
     * @param {*}
     * @return {*}
     */
    createProjectFn (data, isEdit = false, isView = false) {
      console.log(data)
      if (data && data.id) {
        this.projectData = data
        this.projectIsEdit = isEdit
        this.projectIsView = isView
      } else {
        this.projectData = {}
        this.projectIsEdit = false
        this.projectIsView = false
      }
      this.show = 5
    },
    /**
     * @description: 查看创建项目
     * @param {*} data
     * @param {*} isEdit
     * @param {*} isView
     * @return {*}
     */
    createTaskFn (data, isEdit = false, isView = false) {
      // console.log(data)
      if (data && data.id) {
        this.taskData = data
        this.taskIsEdit = isEdit
        this.taskView = isView
        console.log(this.taskView)
      } else {
        this.taskData = {}
        this.taskIsEdit = false
        this.taskIsView = false
      }
      this.show = 4
    },
    /**
     * @description: 退出钱包
     * @param {*}
     * @return {*}
     */
    async exitWallet () {
      // await conflux.disable()
      sessionStorage.clear()
      eventBus.$emit('changeConnect')
      this.$router.push({ name: 'Index' })
    },
    /**
     * @description: 编辑
     * @param {*}
     * @return {*}
     */
    toEdit () {
      this.getUserInfo() // 获取用户信息
      this.show = 1
      this.isDisabled = false
    },
    /**
     * @description: 文件上传成功
     * @param {*} res
     * @param {*} file
     * @return {*}
     */
    handleAvatarSuccess (res, file) {
      // this.imageUrl = file.response.data.url
      this.formData.headPortrait = file.response.data.url
      this.uploadLoading.close()
    },
    /**
     * @description: 上传失败
     * @param {*}
     * @return {*}
     */
    handleError () {
      this.uploadLoading.close()
    },
    /**
     * @description: 文件上传前校验
     * @param {*} file
     * @return {*}
     */
    beforeAvatarUploadImage (file) {
      const isJPG = file.type === 'image/jpeg'
      const isBMP = file.type === 'image/bmp'
      const isPNG = file.type === 'image/png'
      if (!isJPG && !isBMP && !isPNG) {
        this.$message.error(this.$t('allTip.tip6'))
      } else {
        this.uploadLoading = this.$loading({ lock: true, text: this.$t('My.loading'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
      }
      return isJPG || isBMP || isPNG
    },
    /**
     * @description: 获取用户信息
     * @param {*}
     * @return {*}
     */
    getUserInfo () {
      getMyProfile().then(res => {
        // console.log('userinfo', res)
        if (!res.code) {
          const profile = res.data.profile
          const { id, userName, pandaId, pandaStatus, email, headPortrait, remarks } = profile
          this.formData.id = id
          this.formData.userName = userName
          this.formData.pandaId = pandaId
          this.formData.email = email
          this.formData.pandaStatus = pandaStatus
          this.formData.remarks = remarks
          this.formData.headPortrait = headPortrait
          this.token = id
          console.log('this.formData', this.formData)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * @description: 列表页面
     * @param {*}
     * @return {*}
     */
    goList () {
      this.show = 6
    },
    /**
     * @description: 复制url
     * @param {*} data
     * @return {*}
     */
    copyUrl (data) {
      // 获取需要复制的文字
      const copyStr = this.token
      // 创建input标签存放需要复制的文字
      const oInput = document.createElement('input')
      // 把文字放进input中，供复制
      oInput.value = copyStr
      document.body.appendChild(oInput)
      // 选中创建的input
      oInput.select()
      // 执行复制方法， 该方法返回bool类型的结果，告诉我们是否复制成功
      const copyResult = document.execCommand('copy')
      // 操作中完成后 从Dom中删除创建的input
      document.body.removeChild(oInput)
      // 根据返回的复制结果 给用户不同的提示
      if (copyResult) {
        // this.$message({
        //   type: 'success',
        //   offset: 120,
        //   message: 'Copied!'
        // })
        this.showCopy = true
        setTimeout(() => {
          this.showCopy = false
        }, 2000)
      } else {
        this.$message.error(this.$t('allTip.tip7'))
      }
    },
    /**
     * @description: 保存用户信息
     * @param {*}
     * @return {*}
     */
    saveUserInfo () {
      if (this.isDisabled) return false
      updateMyProfile(this.formData).then(res => {
        if (!res.code) {
          this.$message({
            type: 'success',
            offset: 120,
            message: 'success'
          })
          this.bountyName = this.formData.userName
          this.bountyIcon = this.formData.headPortrait
          // 更新头像
          this.$parent.$refs.bountyHeader.openPortal()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * @description: 返回我的页面
     * @param {*}
     * @return {*}
     */
    goBack () {
      this.show = 2
    }
  },
  filters: {
    tokenFilter: function (val) {
      return val ? val.substring(val.length - 13, val.length - 7) + '...' + val.substring(val.length - 4, val.length) : ''
    }
  }
}
</script>
<style lang="scss" scoped>
  .message-num{
    width: 20px;
    height: 20px;
    position: absolute;
    line-height: 20px;
    text-align: center;
    background: #FF6262;
    border-radius: 100%;
    top: -10px;
    left: 60px;
  }
</style>
<style lang="scss">
@import '@/assets/css/gloabal.scss';

.el-checkbox__input.is-checked .el-checkbox__inner{
  background-color: #18D6BE;
  border-color: #18D6BE;
}
.el-checkbox__input.is-checked+.el-checkbox__label{
  color: #18D6BE;
}
.el-checkbox {
  display: flex;
  align-items: center;
  //修改选中框的大小
  .el-checkbox__inner {
    width: 28px;
    height: 28px;
      //修改选中框中的对勾的大小和位置
    &::after {
      height: 14px;
      left: 8px;
    }
  }
}
.upload-file .el-form-item__content{
  width: 160px;
}
.my{
  min-height: calc(100vh - 470px);
  padding: 80px 32px 85px 32px;
  .my-des{
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    .my-left{
      display: flex;
      position: relative;
      // padding-right: 160px;
      .login{
        float: left;
        display: flex;
        margin-right: 16px;
        justify-content: space-between;
        position: relative;
        .login-icon{
          width: 112px;
          height: 112px;
          background: #F8DE94;
          border-radius: 100%;
          position: relative;
          overflow: hidden;
          .login-red-box{
            position: absolute;
            width: 103px;
            height: 103px;
            background: #EE82A0;
            border: 5px solid #E45564;
            top: 33px;
            left: 33px;
            border-radius: 100%;
          }
        }
        .bounty-icon{
          width: 112px;
          height: 112px;
          border-radius: 100%;
        }
        .red-point{
          position: absolute;
          right: 0;
          top: 0;
        }
      }
      .right-box{
        padding-top: 8px;
        .bountyName{
          font-family: $fontFamilyCircularStd;
          font-style: normal;
          font-weight: bold;
          font-size: 34px;
          line-height: 43px;
          margin-bottom: 13px;
        }
        .token{
          font-family: $fontFamilyCircularStd;
          font-style: normal;
          font-weight: normal;
          font-size: 28px;
          span{
            opacity: .6;
          }
          svg{
            width: 30px;
            height: 30px;
            cursor: pointer;
            margin-left: 13px;
            vertical-align: bottom;
          }
        }
      }
      .token-tip{
          // width: 123px;
          padding: 10px;
          // height: 40px;
          // line-height: 40px;
          background: #35353D;
          border-radius: 8px;
          text-align: center;
          font-family: $fontFamilyCircularStd;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          color: #bbb;
          position: absolute;
          top: 44px;
          left: 353px;
        }
    }
    .my-right{
      display: flex;
      justify-content: space-between;
      div{
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 60px;
        width: 60px;
        border-radius: 16px;
        background: #35353D;
        cursor: pointer;
        margin-left: 16px;
        svg{
          width: 36px;
          height: 36px;
        }
      }
    }
  }
  .my-title{
    font-family: $fontFamilyCircularStd;
    font-style: normal;
    font-weight: bold;
    font-size: 34px;
    line-height: 43px;
    margin-top: 48px;
    margin-bottom: 2px;
  }
  .form_wrap{
    // padding-bottom: 87px;
    .form-box{
      // display: flex;
      // justify-content: space-between;
      .el-form-item{
        // width: 41.7%;
        .el-select{
          width: 100%;
        }
        .el-input__suffix {
          .el-select{
            width: 100px;
            .el-input__inner{
              height: 80px !important;
              &:focus{
                border-color: transparent !important;
              }
            }
          }
        }
      }
    }
    .saveBtn{
      display: inline-block;
      background: linear-gradient(96.34deg, #A737FF 0%, #18D6BE 100%);
      border-radius: 40px;
      cursor: pointer;
      margin-top: 54px;
      padding: 21px 64px;
      font-family: $fontFamilyCircularStd;
      font-style: normal;
      font-weight: bold;
      font-size: 30px;
    }
  }
}
.el-form-item{
  margin-bottom: 0 !important;
}
.el-textarea__inner,.el-input__inner,.el-range-input,.el-input-group__append,.el-form-item__content{
  background: #1C1C20 !important;
  font-family: $fontFamilyCircularStd !important;
  border-radius: 8px !important;
  color: #fff !important;
  border-color: #1C1C20 !important;
  &:focus{
    border-color: #1a796f !important;
    outline: 0;
  }
}
</style>
